/**
 * DOG OWNED — product page.
 *
 * Variant-dependent content is already rendered server-side, one block per
 * variant, hidden except the selected one. This file only swaps which block is
 * visible — it never rebuilds markup or reformats money, so there is no second
 * source of truth and the correct variant is correct before JS runs.
 *
 * The hidden `id` input ships disabled so the <noscript> select owns submission
 * when scripting is off. Enabling it here is what makes the radios authoritative.
 */
(function () {
  'use strict';

  function setupVariants(root) {
    var picker = root.querySelector('[data-variant-picker]');
    if (!picker) return;

    var hiddenId = picker.querySelector('[data-variant-id]');
    if (!hiddenId) return;

    // Scripting is available, so the radios drive the form from here.
    hiddenId.disabled = false;

    var panels = root.querySelectorAll('[data-variant-panel]');
    var measurements = root.querySelectorAll('[data-variant-measurements]');

    // One button for the whole form. Its label and disabled state follow the
    // selected variant — there is deliberately no button per variant.
    var addButton = root.querySelector('[data-add-button]');
    var addLabel = root.querySelector('[data-add-label]');

    function selectedKey() {
      var groups = picker.querySelectorAll('[data-option-index]');
      var values = [];
      Array.prototype.forEach.call(groups, function (group) {
        var checked = group.querySelector('[data-option-input]:checked');
        values.push(checked ? checked.value : '');
      });
      return values.join('||');
    }

    function update() {
      var key = selectedKey();
      var match = null;

      Array.prototype.forEach.call(panels, function (p) {
        if (p.getAttribute('data-options') === key) match = p;
      });

      // Combination does not exist (e.g. that colour is not made in that size).
      if (!match) {
        Array.prototype.forEach.call(panels, function (p) { p.hidden = true; });
        if (addButton) {
          addButton.disabled = true;
          if (addLabel) addLabel.textContent = addButton.getAttribute('data-label-sold');
        }
        return;
      }

      var id = match.getAttribute('data-variant-panel');
      hiddenId.value = id;

      Array.prototype.forEach.call(panels, function (p) {
        p.hidden = p.getAttribute('data-variant-panel') !== id;
      });
      Array.prototype.forEach.call(measurements, function (m) {
        m.hidden = m.getAttribute('data-variant-measurements') !== id;
      });

      if (addButton) {
        var available = match.getAttribute('data-available') === 'true';
        addButton.disabled = !available;
        if (addLabel) {
          addLabel.textContent = addButton.getAttribute(available ? 'data-label-add' : 'data-label-sold');
        }
      }

      // Reflect the selection in each option legend.
      var groups = picker.querySelectorAll('[data-option-index]');
      Array.prototype.forEach.call(groups, function (group) {
        var idx = group.getAttribute('data-option-index');
        var checked = group.querySelector('[data-option-input]:checked');
        var label = picker.querySelector('[data-option-selected="' + idx + '"]');
        if (label && checked) label.textContent = checked.value;
      });

      // Keep the URL shareable without adding a history entry per click.
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    picker.addEventListener('change', function (event) {
      if (event.target.matches('[data-option-input]')) update();
    });

    update();
  }

  function setupGallery(root) {
    var gallery = root.querySelector('[data-gallery]');
    if (!gallery) return;

    var items = gallery.querySelectorAll('[data-gallery-item]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    if (!thumbs.length) return;

    gallery.addEventListener('click', function (event) {
      var thumb = event.target.closest('[data-gallery-thumb]');
      if (!thumb) return;
      var id = thumb.getAttribute('data-gallery-thumb');

      Array.prototype.forEach.call(items, function (i) {
        i.hidden = i.getAttribute('data-gallery-item') !== id;
      });
      Array.prototype.forEach.call(thumbs, function (t) {
        if (t === thumb) t.setAttribute('aria-current', 'true');
        else t.removeAttribute('aria-current');
      });
    });
  }

  function init(scope) {
    var root = scope || document;
    Array.prototype.forEach.call(root.querySelectorAll('.product'), function (p) {
      setupVariants(p);
      setupGallery(p);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // The theme editor re-renders sections without a full page load.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
/* Show the chosen breed's picture when a variant is picked. */
(function () {
  function start() {
    var picker = document.querySelector('[data-variant-picker]');
    var gallery = document.querySelector('[data-gallery]');
    if (!picker || !gallery) return;
    var hiddenId = picker.querySelector('[data-variant-id]');
    var handle = (location.pathname.split('/products/')[1] || '').split('/')[0];
    if (!hiddenId || !handle) return;
    var map = null;

    function showVariantImage() {
      if (!map) return;
      var mediaId = map[hiddenId.value];
      if (!mediaId) return;
      var thumb = gallery.querySelector('[data-gallery-thumb="' + mediaId + '"]');
      if (thumb) thumb.click();
    }

    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        map = {};
        p.variants.forEach(function (v) {
          if (v.featured_media) map[v.id] = v.featured_media.id;
        });
        showVariantImage();
      });

    picker.addEventListener('change', function () { setTimeout(showVariantImage, 0); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
/* Product gallery carousel: arrows, swipe, keyboard and a one-row thumbnail strip. */
(function () {
  var ARROW = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';

  function setupCarousel(gallery) {
    if (gallery.hasAttribute('data-carousel-ready')) return;
    var main = gallery.querySelector('.product-gallery__main');
    var strip = gallery.querySelector('.product-gallery__thumbs');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    if (!main || !strip || thumbs.length < 2) return;
    gallery.setAttribute('data-carousel-ready', '');

    function current() {
      for (var i = 0; i < thumbs.length; i++) {
        if (thumbs[i].getAttribute('aria-current') === 'true') return i;
      }
      return 0;
    }
    function go(step) {
      thumbs[(current() + step + thumbs.length) % thumbs.length].click();
    }
    function arrow(dir, label, step) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'product-gallery__arrow product-gallery__arrow--' + dir;
      b.setAttribute('aria-label', label);
      b.innerHTML = dir === 'next' ? ARROW.replace('M15 5l-7 7 7 7', 'M9 5l7 7-7 7') : ARROW;
      b.addEventListener('click', function () { go(step); });
      return b;
    }

    var counter = document.createElement('div');
    counter.className = 'product-gallery__count';
    main.appendChild(arrow('prev', 'Previous image', -1));
    main.appendChild(arrow('next', 'Next image', 1));
    main.appendChild(counter);

    function sync() {
      var i = current();
      counter.textContent = (i + 1) + ' / ' + thumbs.length;
      var t = thumbs[i].getBoundingClientRect(), s = strip.getBoundingClientRect();
      strip.scrollTo({ left: strip.scrollLeft + (t.left - s.left) - (s.width - t.width) / 2, behavior: 'smooth' });
    }
    gallery.addEventListener('click', function () { setTimeout(sync, 0); });

    // Swipe on phones
    var startX = null, startY = null;
    main.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX; startY = e.touches[0].clientY;
    }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX, dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? 1 : -1);
      startX = null;
    });

    // Left/right arrow keys
    gallery.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
    });

    sync();
  }

  function initCarousels(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-gallery]'), setupCarousel);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initCarousels(); });
  } else {
    initCarousels();
  }
  document.addEventListener('shopify:section:load', function (e) { initCarousels(e.target); });
})();